var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import SDK from '../sdk';
import intlUtil from '../intl';
import { IMState } from '../interface/state-interface';
console.log(SDK);
var imInstance;
var storeCache;
var errorMap = {
    ACCS_CLOSED: intlUtil.getLocale('page.im.window.disconnected'),
    UNKNOWN_ERROR: intlUtil.getLocale('page.im.window.unknownError'),
};
function getErrorInfo(type) {
    return errorMap[type] || errorMap.UNKNOWN_ERROR;
}
var IMSDKUtil = (function () {
    function IMSDKUtil() {
        this.config = {};
        this.store = {};
        this.onError = function (_a) {
            var type = _a.type, msg = _a.msg, flag = _a.flag;
            if (flag === 'notLogin') {
                storeCache.updateData({
                    imState: IMState.notLogin,
                    notLogin: true,
                    isImLoading: false,
                });
                return;
            }
            storeCache.updateData({
                isImError: true,
                imState: IMState.error,
                imErrorReason: getErrorInfo(type)
            });
        };
        this.messageWithdraw = function (messageId) {
            storeCache.deleteMessage(messageId);
        };
    }
    IMSDKUtil.prototype.init = function (config, store) {
        if (config === void 0) { config = this.config; }
        return __awaiter(this, void 0, void 0, function () {
            var im, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (store) {
                            this.store = storeCache = store;
                        }
                        this.config = config;
                        Object.assign(errorMap, config.errorMap);
                        this.store.updateData({
                            isImLoading: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, window.lib.imSDK(config)];
                    case 2:
                        im = _a.sent();
                        imInstance = im;
                        this.bindEvent();
                        if (imInstance.refreshSessionData) {
                            imInstance.refreshSessionData();
                        }
                        this.store.updateData({
                            isImError: false,
                            isImLoading: false,
                            imState: IMState.success
                        });
                        return [2, im];
                    case 3:
                        ex_1 = _a.sent();
                        this.store.updateData({
                            isImLoading: false,
                            isImError: true,
                            imState: IMState.error,
                        });
                        throw ex_1;
                    case 4: return [2];
                }
            });
        });
    };
    IMSDKUtil.prototype.reInit = function (config) {
        var _this = this;
        this.store.updateData({
            messageList: [],
            sessionList: [],
            isImLoading: true,
        });
        if (imInstance) {
            return imInstance.close()
                .then(function () { return _this.init(); });
        }
        else {
            return this.init(config);
        }
    };
    IMSDKUtil.prototype.bindEvent = function () {
        imInstance.off('messageListUpdate', this.messageListUpdate);
        imInstance.on('messageListUpdate', this.messageListUpdate);
        imInstance.off('messageWithdraw', this.messageWithdraw);
        imInstance.on('messageWithdraw', this.messageWithdraw);
        imInstance.off('sessionListUpdate', this.sessionListUpdate);
        imInstance.on('sessionListUpdate', this.sessionListUpdate);
        imInstance.off('readNewMessage', this.onReadNewMessage);
        imInstance.on('readNewMessage', this.onReadNewMessage);
        imInstance.off('reconnecting', this.onNetworkConnecting);
        imInstance.on('reconnecting', this.onNetworkConnecting);
        imInstance.off('reconnected', this.onNetworkConnected);
        imInstance.on('reconnected', this.onNetworkConnected);
        imInstance.off('error', this.onError);
        imInstance.on('error', this.onError);
        imInstance.off('sessionTimeout', this.onError);
        imInstance.on('sessionTimeout', this.onError);
    };
    IMSDKUtil.prototype.getImInstance = function () {
        return imInstance;
    };
    IMSDKUtil.prototype.messageListUpdate = function (messageList) {
        storeCache.updateMessage(messageList);
    };
    IMSDKUtil.prototype.sessionListUpdate = function (sessionList) {
        console.log('sessionListUpdate');
        storeCache.updateData({
            sessionList: sessionList,
            isMoreSessionLoading: false
        });
    };
    IMSDKUtil.prototype.onReadNewMessage = function (message) {
        storeCache.readNewMessage(message);
    };
    IMSDKUtil.prototype.onNetworkConnecting = function () {
        storeCache.updateData({
            isConnecting: true
        });
    };
    IMSDKUtil.prototype.onNetworkConnected = function () {
        storeCache.updateData({
            isConnecting: false
        });
    };
    return IMSDKUtil;
}());
export { IMSDKUtil };
export default new IMSDKUtil();
